import React, { Children } from 'react';
import { LegalLayout, LegalSection } from '../components/page/LegalLayout';
const sections: LegalSection[] = [{
  heading: 'Introduction',
  blocks: [{
    type: 'p',
    text: 'Welcome to Zano. This Privacy Policy outlines how we collect, use, and protect your personal information when you visit our website and use our services. By using Zano, you agree to the terms of this Privacy Policy.'
  }]
}, {
  heading: 'Information We Collect',
  blocks: [{
    type: 'p',
    text: 'We collect personal information that you voluntarily provide to us when you fill out the form on our Start for Free page. This information includes:'
  }, {
    type: 'list',
    items: ['Name', 'Email address', 'Any other information you choose to provide in the form']
  }, {
    type: 'p',
    text: 'Once you are invited to join the platform, we may collect additional information such as:'
  }, {
    type: 'list',
    items: ['Roster of influencers', 'Agency contact details (phone number, email address, website, agent/manager name)', 'Influencer details (name, exclusivity, social media links, pricing, etc.)']
  }]
}, {
  heading: 'How We Use Your Information',
  blocks: [{
    type: 'p',
    text: 'The information we collect is used for the following purposes:'
  }, {
    type: 'list',
    items: ['To understand who you are and assess your eligibility to join our invite-only platform.', 'To contact you if you are qualified to join the platform.', 'To send you an invite email with access details if you are eligible.', 'To allow users to upload and manage their roster of influencers.', 'To enable users to share selected influencer information with other agents/managers on the platform.']
  }, {
    type: 'p',
    text: "Within the Zano platform, agencies (users) are able to view other agencies' (users') influencers along with the contact details of the respective agent/user. This information is visible to all users of the platform."
  }, {
    type: 'p',
    text: "In the future, we may incorporate a version of Zano that is accessible to brands to view agency rosters with the agency's contact information. If such a change happens, we will allow users to hide influencers/edit the details shown to brands and we will notify users of this change ahead of time."
  }]
}, {
  heading: 'Sharing of Personal Information',
  blocks: [{
    type: 'p',
    text: 'We do not share your personal information with third parties outside of the platform. Information shared within the platform is controlled by the users, who decide which influencers to make visible to other agents/managers.'
  }]
}, {
  heading: 'Protecting Your Personal Information',
  blocks: [{
    type: 'p',
    text: 'We take the security of your personal information seriously. While we implement various security measures to protect your data, it is important to note that no method of transmission over the internet or method of electronic storage is 100% secure. We strive to use commercially acceptable means to protect your personal information.'
  }]
}, {
  heading: 'Payments and Billing Information',
  blocks: [{
    type: 'p',
    text: 'If you choose to subscribe to our services:'
  }, {
    type: 'list',
    items: ['We will collect payment information, such as credit card details, through our payment processor, Stripe.', 'Credit card information is securely handled by Stripe, and we do not store it on our servers.', 'Your first payment will be processed four weeks after starting your free trial.', 'Subsequent payments will be charged monthly on the same day of the month.', 'You will receive a receipt via email immediately after each payment.', 'You can also access invoices/receipts within your account on the Zano platform.']
  }]
}, {
  heading: 'User Rights',
  blocks: [{
    type: 'p',
    text: 'You have the right to:'
  }, {
    type: 'list',
    items: ['Access the personal information we hold about you.', 'Correct any inaccuracies in your personal information.', 'Update your personal and billing information through the "Account" page.']
  }, {
    type: 'p',
    text: 'If you wish to correct your information, you can contact us at support@zanoplatform.com or submit a new form.'
  }]
}, {
  heading: 'Cookies and Tracking Technologies',
  blocks: [{
    type: 'p',
    text: 'We currently do not use cookies or other tracking technologies on our website. If this changes in the future, we will update this policy and notify users accordingly.'
  }]
}, {
  heading: 'Third-Party Links',
  blocks: [{
    type: 'p',
    text: 'Our website does not contain links to third-party sites.'
  }]
}, {
  heading: "Children's Privacy",
  blocks: [{
    type: 'p',
    text: 'We do not collect personal information from children under the age of 13. If we become aware that we have inadvertently received personal information from a child under the age of 13, we will delete such information from our records.'
  }]
}, {
  heading: 'Changes to This Privacy Policy',
  blocks: [{
    type: 'p',
    text: 'We may update this Privacy Policy from time to time. If we make any changes, we will notify users who have submitted a form via email. We encourage you to review this policy periodically to stay informed about how we are protecting your information.'
  }]
}, {
  heading: 'Contact Us',
  blocks: [{
    type: 'p',
    text: 'If you have any questions about this Privacy Policy or your personal information, please contact us at support@zanoplatform.com.'
  }]
}];
export const PrivacyPolicy = () => {
  return <LegalLayout title="Privacy Policy" subtitle="How we handle your data." updated="July 17, 2024" sections={sections} data-id="element-2495" data-mp="2otqh78q3dnn5" />;
};